const zhCN = {
    title: '插件 Token 额度与使用量',
    description: '永久 Token 余额、Codex 实际消耗及文档维度统计',
    permanentBalanceNote: '余额为永久余额，不随筛选时间变化。',
    pricingFormulaNote: '官方计费公式：费用（USD）＝［（输入 Token－缓存输入 Token）× 普通输入单价＋缓存输入 Token × 缓存输入单价＋输出 Token × 输出单价］÷ 1,000,000。',
    config: {
        title: '全局配置',
        notConfigured: '尚未配置，保存后将作为新用户的默认 Token 配置。',
        defaultGrant: '新内测用户默认发放 Token',
        warningThreshold: '余额预警阈值（%）',
        blockInsufficient: '余额不足时禁止创建新 Run',
        modelPricingTitle: '模型价格映射',
        modelPricingHint: '单位为 USD / 100 万 Token。',
        modelName: '实际计费模型',
        enabled: '启用',
        inputPrice: '普通输入单价',
        cachedInputPrice: '缓存输入单价',
        outputPrice: '输出单价',
        pricingVersion: '当前价格版本',
        modelRoutingTitle: 'auto 模型路由',
        modelRoutingHint: '插件用户始终只看到 auto，实际模型仅在此管理后台和账单中可见。',
        autoEnabled: '启用 auto 路由',
        resolvedModel: 'auto 对应实际模型',
    },
    summary: {
        periodTokens: '当前筛选期 Token 消耗',
        periodHint: '仅统计筛选时间范围',
        availableTokens: '永久总可用 Token',
        permanentHint: '永久余额',
        avgDocuments: '人均文档数',
        activeUsers: '位活跃用户',
        avgTokens: '人均 Token 消耗',
        cached: '缓存 Token',
        insufficientUsers: '余额不足用户',
        insufficientHint: '含停用、预警和超额',
        estimatedCost: '筛选期预估费用',
        unpricedUsage: '条未计价',
        allPriced: '全部流水已计价',
    },
    filters: {
        startAt: '开始时间',
        endAt: '结束时间',
        labels: '用户标签',
        search: '邮箱或用户 ID',
        periodTokens: '筛选期 Token',
        availableTokens: '可用 Token',
        lifetimeTokens: '累计消耗',
        documentCount: '文档数',
        lastUsedAt: '最近使用',
        desc: '降序',
        asc: '升序',
    },
    table: {
        user: '用户',
        labels: '标签',
        documents: '文档数',
        consumed: '累计消耗',
        periodConsumed: '筛选期消耗',
        lifetime: '累计',
        available: 'Token 余额',
        usageRate: '使用率',
        cachedTokens: '缓存 Token',
        estimatedCost: '预估费用',
        cacheRatio: '缓存占比',
        status: '状态',
        actions: '操作',
    },
    detail: {
        drawerTitle: '用户 Token 消耗明细',
        email: '邮箱',
        userId: '用户 ID',
        company: '公司',
        empty: '当前筛选期暂无文档消耗',
        documentListTitle: '写入文档明细',
        userAnalysis: '用户分析',
        documents: '文档数',
        avgPerDocument: '平均 Token/文档',
        avgPerChat: '平均 Token/会话',
        periodTotal: '筛选期总 Token',
        cacheRatio: '缓存 Token 占比',
        inputOutput: '输入 / 输出 Token',
        document: '文档',
        untitled: '未命名文档',
        chats: '会话数',
        runs: 'Run 数',
        tokens: 'Token 消耗',
        sessionListTitle: '会话明细',
        session: '会话',
        untitledChat: '未命名会话',
        model: '模型',
        inputTokens: '输入 Token',
        outputTokens: '输出 Token',
        cachedInputTokens: '缓存 Token',
        totalTokens: '总 Token',
        estimatedCost: '预估费用',
        emptySessions: '当前文档暂无 Token 会话',
        lastUsedAt: '最近消耗时间',
    },
    status: {
        normal: '正常',
        insufficient: '余额不足',
        exceeded: '已超额',
        blocked: '已停用',
    },
    adjust: {
        title: '用户 Token 配置调整',
        batchTitle: '批量调整用户配置',
        selectedUsers: '个已选用户',
        currentBalance: '当前余额',
        delta: 'Token 余额调整（选填）',
        balanceAfter: '调整后余额',
        labels: '用户标签（选填，可输入创建）',
        labelOperation: '标签操作（选填）',
        labelAppend: '追加标签',
        labelRemove: '移除标签',
        labelReplace: '替换标签',
        noStatusChange: '不修改状态',
        status: '账户状态',
        remark: '备注（选填）',
        invalidDelta: 'Token 调整数量必须是整数',
        noChanges: '请至少修改一项配置',
        riskTitle: '确认危险调整',
        riskMessage: '本次调整可能导致用户无法创建新的插件 Run，是否继续？',
        batchRiskMessage: '本次批量调整可能导致部分用户无法创建新的插件 Run，是否继续？',
    },
    backfill: {
        confirmTitle: '确认历史数据计价',
        confirmPrefix: '将对全部',
        confirmSuffix: '条未计价历史使用记录执行计价，与当前筛选条件无关。是否继续？',
        noCandidates: '没有需要计价的历史使用记录',
        completed: '历史计价完成：',
        priced: '已计价',
        skipped: '跳过',
    },
    actions: {
        save: '保存配置',
        search: '查询',
        reset: '重置',
        refresh: '刷新',
        viewDetails: '查看明细',
        expand: '展开明细',
        collapse: '收起明细',
        adjust: '配置调整',
        batchAdjust: '批量调整用户配置',
        backfillCosts: '一键计价历史数据',
        cancel: '取消',
        confirm: '确认',
        addModel: '添加模型',
        remove: '移除',
        savePricing: '保存价格映射',
        saveRouting: '保存 auto 路由',
    },
    messages: {
        loadFailed: '加载插件 Token 使用量失败',
        detailFailed: '加载文档明细失败',
        configLoadFailed: '加载插件 Token 配置失败',
        labelsLoadFailed: '加载用户标签失败',
        configSaved: '配置已保存',
        configSaveFailed: '保存插件 Token 配置失败',
        pricingSaved: '模型价格映射已保存',
        pricingSaveFailed: '保存模型价格映射失败',
        routingSaved: 'auto 模型路由已保存',
        routingSaveFailed: '保存 auto 模型路由失败',
        adjusted: '用户 Token 配置已保存',
        adjustFailed: '保存用户 Token 配置失败',
        batchAdjusted: '批量用户配置已保存',
        batchAdjustFailed: '保存批量用户配置失败',
        backfillCountFailed: '获取未计价历史记录数量失败',
        backfillFailed: '历史使用记录计价失败',
    },
};

const zhTW = {
    ...zhCN,
    title: '外掛 Token 額度與使用量',
    description: '永久 Token 餘額、Codex 實際消耗及文件維度統計',
    permanentBalanceNote: '餘額為永久餘額，不隨篩選時間變化。',
    pricingFormulaNote: '官方計費公式：費用（USD）＝［（輸入 Token－快取輸入 Token）× 一般輸入單價＋快取輸入 Token × 快取輸入單價＋輸出 Token × 輸出單價］÷ 1,000,000。',
    config: {
        ...zhCN.config,
        title: '全域設定',
        notConfigured: '尚未設定，儲存後將作為新使用者的預設 Token 設定。',
        defaultGrant: '新內測使用者預設發放 Token',
        warningThreshold: '餘額預警門檻（%）',
        blockInsufficient: '餘額不足時禁止建立新 Run',
    },
    filters: {
        ...zhCN.filters,
        search: '信箱或使用者 ID',
    },
    table: {
        ...zhCN.table,
        user: '使用者',
        labels: '標籤',
        documents: '文件數',
        periodConsumed: '篩選期消耗',
        lifetime: '累計',
        available: 'Token 餘額',
        usageRate: '使用率',
        cachedTokens: '快取 Token',
        cacheRatio: '快取占比',
        status: '狀態',
        actions: '操作',
    },
    detail: {
        ...zhCN.detail,
        drawerTitle: '使用者 Token 消耗明細',
        email: '信箱',
        userId: '使用者 ID',
        company: '公司',
        empty: '目前篩選期暫無文件消耗',
        documentListTitle: '寫入文件明細',
        userAnalysis: '使用者分析',
        documents: '文件數',
        avgPerDocument: '平均 Token/文件',
        avgPerChat: '平均 Token/會話',
        periodTotal: '篩選期總 Token',
        cacheRatio: '快取 Token 占比',
        document: '文件',
        untitled: '未命名文件',
        sessionListTitle: '會話明細',
        session: '會話',
        untitledChat: '未命名會話',
        inputTokens: '輸入 Token',
        outputTokens: '輸出 Token',
        cachedInputTokens: '快取 Token',
        totalTokens: '總 Token',
        emptySessions: '目前文件暫無 Token 會話',
        lastUsedAt: '最近消耗時間',
    },
    actions: {
        ...zhCN.actions,
        save: '儲存設定',
        search: '查詢',
        reset: '重設',
        viewDetails: '查看明細',
        expand: '展開明細',
        collapse: '收起明細',
        adjust: '設定調整',
    },
    adjust: {
        ...zhCN.adjust,
        title: '使用者 Token 設定調整',
        currentBalance: '目前餘額',
        delta: 'Token 餘額調整（選填）',
        balanceAfter: '調整後餘額',
        labels: '使用者標籤（選填，可輸入建立）',
        status: '帳戶狀態',
        remark: '備註（選填）',
        invalidDelta: 'Token 調整數量必須是整數',
        noChanges: '請至少修改一項設定',
    },
};

const enUS = {
    title: 'Add-in Token Balance & Usage',
    description: 'Permanent balances, actual Codex usage, and document-level metrics',
    permanentBalanceNote: 'Balances are permanent and do not change with the selected date range.',
    pricingFormulaNote: 'Official pricing formula: Cost (USD) = [(input tokens − cached input tokens) × input price + cached input tokens × cached input price + output tokens × output price] ÷ 1,000,000.',
    config: {
        title: 'Global Configuration',
        notConfigured: 'Not configured. Save to create the default Token settings for new users.',
        defaultGrant: 'Default tokens for new test users',
        warningThreshold: 'Balance warning threshold (%)',
        blockInsufficient: 'Block new Runs when balance is insufficient',
        modelPricingTitle: 'Model pricing map',
        modelPricingHint: 'USD per 1M tokens.',
        modelName: 'Billing model',
        enabled: 'Enabled',
        inputPrice: 'Input price',
        cachedInputPrice: 'Cached input price',
        outputPrice: 'Output price',
        pricingVersion: 'Current pricing version',
        modelRoutingTitle: 'auto model route',
        modelRoutingHint: 'Add-in users only see auto; the resolved model is private to this admin view and billing records.',
        autoEnabled: 'Enable auto route',
        resolvedModel: 'Resolved model for auto',
    },
    summary: {
        periodTokens: 'Tokens in selected period',
        periodHint: 'Selected period only',
        availableTokens: 'Total permanent balance',
        permanentHint: 'Permanent balance',
        avgDocuments: 'Documents per user',
        activeUsers: 'active users',
        avgTokens: 'Tokens per user',
        cached: 'Cached tokens',
        insufficientUsers: 'Users needing attention',
        insufficientHint: 'Blocked, warning, or exceeded',
        estimatedCost: 'Estimated cost in period',
        unpricedUsage: 'unpriced entries',
        allPriced: 'All entries priced',
    },
    filters: {
        startAt: 'Start time',
        endAt: 'End time',
        labels: 'User labels',
        search: 'Email or user ID',
        periodTokens: 'Period tokens',
        availableTokens: 'Available tokens',
        lifetimeTokens: 'Lifetime usage',
        documentCount: 'Documents',
        lastUsedAt: 'Last used',
        desc: 'Descending',
        asc: 'Ascending',
    },
    table: {
        user: 'User',
        labels: 'Labels',
        documents: 'Documents',
        consumed: 'Lifetime usage',
        periodConsumed: 'Period usage',
        lifetime: 'Lifetime',
        available: 'Token balance',
        usageRate: 'Usage rate',
        cachedTokens: 'Cached tokens',
        estimatedCost: 'Estimated cost',
        cacheRatio: 'Cache ratio',
        status: 'Status',
        actions: 'Actions',
    },
    detail: {
        drawerTitle: 'User Token Usage Details',
        email: 'Email',
        userId: 'User ID',
        company: 'Company',
        empty: 'No document usage in this period',
        documentListTitle: 'Written document details',
        userAnalysis: 'User analysis',
        documents: 'Documents',
        avgPerDocument: 'Avg tokens/document',
        avgPerChat: 'Avg tokens/chat',
        periodTotal: 'Period tokens',
        cacheRatio: 'Cached token ratio',
        inputOutput: 'Input / output tokens',
        document: 'Document',
        untitled: 'Untitled document',
        chats: 'Chats',
        runs: 'Runs',
        tokens: 'Token usage',
        sessionListTitle: 'Session details',
        session: 'Session',
        untitledChat: 'Untitled session',
        model: 'Model',
        inputTokens: 'Input tokens',
        outputTokens: 'Output tokens',
        cachedInputTokens: 'Cached tokens',
        totalTokens: 'Total tokens',
        estimatedCost: 'Estimated cost',
        emptySessions: 'No token-consuming sessions for this document',
        lastUsedAt: 'Last usage',
    },
    status: {
        normal: 'Normal',
        insufficient: 'Low balance',
        exceeded: 'Exceeded',
        blocked: 'Blocked',
    },
    adjust: {
        title: 'Configure User Token Account',
        batchTitle: 'Batch Configure User Accounts',
        selectedUsers: 'users selected',
        currentBalance: 'Current balance',
        delta: 'Token balance adjustment (optional)',
        balanceAfter: 'Balance after adjustment',
        labels: 'User labels (optional, custom values allowed)',
        labelOperation: 'Label operation (optional)',
        labelAppend: 'Append labels',
        labelRemove: 'Remove labels',
        labelReplace: 'Replace labels',
        noStatusChange: 'Do not change status',
        status: 'Account status',
        remark: 'Remark (optional)',
        invalidDelta: 'The token adjustment must be an integer',
        noChanges: 'Change at least one configuration value',
        riskTitle: 'Confirm Risky Adjustment',
        riskMessage: 'This adjustment may prevent the user from starting new add-in Runs. Continue?',
        batchRiskMessage: 'This batch adjustment may prevent some users from starting new add-in Runs. Continue?',
    },
    backfill: {
        confirmTitle: 'Confirm historical pricing',
        confirmPrefix: 'Price all',
        confirmSuffix: 'unpriced historical usage records, independent of the current filters. Continue?',
        noCandidates: 'There are no historical usage records awaiting pricing',
        completed: 'Historical pricing completed:',
        priced: 'priced',
        skipped: 'skipped',
    },
    actions: {
        save: 'Save configuration',
        search: 'Search',
        reset: 'Reset',
        refresh: 'Refresh',
        viewDetails: 'View details',
        expand: 'Show details',
        collapse: 'Hide details',
        adjust: 'Configure',
        batchAdjust: 'Batch configure users',
        backfillCosts: 'Price historical usage',
        cancel: 'Cancel',
        confirm: 'Confirm',
        addModel: 'Add model',
        remove: 'Remove',
        savePricing: 'Save pricing map',
        saveRouting: 'Save auto route',
    },
    messages: {
        loadFailed: 'Failed to load add-in token usage',
        detailFailed: 'Failed to load document details',
        configLoadFailed: 'Failed to load add-in token configuration',
        labelsLoadFailed: 'Failed to load user labels',
        configSaved: 'Configuration saved',
        configSaveFailed: 'Failed to save add-in token configuration',
        pricingSaved: 'Model pricing map saved',
        pricingSaveFailed: 'Failed to save model pricing map',
        routingSaved: 'auto model route saved',
        routingSaveFailed: 'Failed to save auto model route',
        adjusted: 'User token configuration saved',
        adjustFailed: 'Failed to save user token configuration',
        batchAdjusted: 'Batch user configuration saved',
        batchAdjustFailed: 'Failed to save batch user configuration',
        backfillCountFailed: 'Failed to load the unpriced historical usage count',
        backfillFailed: 'Failed to price historical usage records',
    },
};

const jaJP = {
    ...enUS,
    title: 'アドイン Token 残高と使用量',
    description: '永久 Token 残高、Codex の実使用量、文書別統計',
    permanentBalanceNote: '残高は無期限で、選択した期間によって変わりません。',
    pricingFormulaNote: '公式料金計算式：料金（USD）＝［（入力 Token－キャッシュ入力 Token）× 通常入力単価＋キャッシュ入力 Token × キャッシュ入力単価＋出力 Token × 出力単価］÷ 1,000,000。',
    config: {
        ...enUS.config,
        title: 'グローバル設定',
        notConfigured: '未設定です。保存すると、新規ユーザー向けの既定 Token 設定が作成されます。',
        defaultGrant: '新規テストユーザーの初期 Token',
        warningThreshold: '残高警告しきい値（%）',
        blockInsufficient: '残高不足時に新規 Run を禁止',
    },
    filters: {
        ...enUS.filters,
        search: 'メールアドレスまたはユーザー ID',
    },
    table: {
        ...enUS.table,
        user: 'ユーザー',
        labels: 'ラベル',
        documents: '文書数',
        periodConsumed: '期間内の消費',
        lifetime: '累計',
        available: 'Token 残高',
        usageRate: '使用率',
        cachedTokens: 'キャッシュ Token',
        cacheRatio: 'キャッシュ比率',
        status: '状態',
        actions: '操作',
    },
    detail: {
        ...enUS.detail,
        drawerTitle: 'ユーザー Token 消費の詳細',
        email: 'メールアドレス',
        userId: 'ユーザー ID',
        company: '会社',
        empty: '選択期間に文書の消費はありません',
        documentListTitle: '書き込み文書の詳細',
        userAnalysis: 'ユーザー分析',
        documents: '文書数',
        avgPerDocument: '文書あたり平均 Token',
        avgPerChat: '会話あたり平均 Token',
        periodTotal: '期間内 Token',
        cacheRatio: 'キャッシュ Token 比率',
        document: '文書',
        untitled: '無題の文書',
        chats: '会話数',
        runs: 'Run 数',
        tokens: 'Token 消費',
        sessionListTitle: '会話の詳細',
        session: '会話',
        untitledChat: '無題の会話',
        model: 'モデル',
        inputTokens: '入力 Token',
        outputTokens: '出力 Token',
        cachedInputTokens: 'キャッシュ Token',
        totalTokens: '合計 Token',
        emptySessions: 'この文書には Token を消費した会話がありません',
        lastUsedAt: '最終消費時刻',
    },
    actions: {
        ...enUS.actions,
        save: '設定を保存',
        search: '検索',
        reset: 'リセット',
        viewDetails: '詳細を表示',
        expand: '詳細を表示',
        collapse: '詳細を閉じる',
        adjust: '設定を変更',
    },
    adjust: {
        ...enUS.adjust,
        title: 'ユーザー Token 設定の変更',
        currentBalance: '現在の残高',
        delta: 'Token 残高の調整（任意）',
        balanceAfter: '調整後の残高',
        labels: 'ユーザーラベル（任意・新規作成可）',
        status: 'アカウント状態',
        remark: '備考（任意）',
        invalidDelta: 'Token 調整数は整数で入力してください',
        noChanges: '少なくとも1つの設定を変更してください',
    },
};

export { enUS, jaJP, zhCN, zhTW };
